import { FC, useState } from 'react';

import { Button, Popover, Table, Text } from '@mantine/core';

import { IRenter } from '@/shared/types/renter.types';
import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconX } from '@tabler/icons-react';

type RenterItemProps = {
	renter: IRenter;
	handleEdit: (renter: IRenter) => void;
	handleDelete: (id: number) => Promise<void>;
};

export const RenterItem: FC<RenterItemProps> = ({ renter, handleEdit, handleDelete }) => {
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Table.Tr>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{renter.renter_name}
				</Text>
			</Table.Td>
			<Table.Td ta="right" style={{ width: '1%', whiteSpace: 'nowrap' }}>
				<Button.Group display="flex" style={{ justifyContent: 'flex-end' }}>
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="black"
						onClick={() => handleEdit(renter)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>
					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="black"
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete fontSize={20} color="#667085" cursor="pointer" />
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Text ta="center" fz={13}>
								Удалить?
							</Text>
							<Button.Group mt={3}>
								<Button
									variant="light"
									size="compact-xs"
									radius="sm"
									onClick={() => {
										void handleDelete(renter.id);
										setIsPopoverOpen(false);
									}}
								>
									<IconCheck size={16} />
								</Button>
								<Button
									variant="light"
									size="compact-xs"
									radius="sm"
									color="red"
									onClick={() => setIsPopoverOpen(false)}
								>
									<IconX size={16} />
								</Button>
							</Button.Group>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			</Table.Td>
		</Table.Tr>
	);
};
